import { DOCUMENTS_MAX_SIZE_GB, ICON_CIRCLE_STYLES } from '@sib/config';
import { useTranslation } from '@sib/i18n';
import { Button, cn } from '@sib/ui';
import { Upload } from '@sib/ui/icons';

interface FullScreenDropzoneViewProps {
  onOpenFileManager: () => void;
}
export const FullScreenDropzoneView = ({
  onOpenFileManager,
}: FullScreenDropzoneViewProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <div className="border-primary flex h-full w-full flex-col items-center justify-center rounded-lg border-2 border-dashed">
        <Upload
          className={cn(ICON_CIRCLE_STYLES, 'text-primary size-34')}
          aria-hidden="true"
        />
        <div className="my-7">
          <p className="text-primary text-4xl font-medium">
            {t('fileManager.dragDrop')}
          </p>
          <div className="mt-4">
            <p className="text-primary text-xl font-medium">
              {t('fileManager.dropfiles')}
            </p>
            <p className="text-muted-foreground">
              {t('fileManager.supported')}
            </p>
            <p className="text-muted-foreground">
              {t('fileManager.maxFileSize', {
                size: `${DOCUMENTS_MAX_SIZE_GB} GB`,
              })}
            </p>
          </div>
        </div>
        <Button onClick={onOpenFileManager}>{t('fileManager.browser')}</Button>
      </div>
    </div>
  );
};
